export default class ResponseError {
  constructor(name, message) {
    this.name = name;
    this.message = message;
  }
  name: string;
  message: string;
}
